import { ToolbarSearch } from '../../../sharedComponents/filter/ToolbarSearch';
import { getServiceOrderSearch, setServiceOrderSearch } from '../../../reducers/serviceOrdersSlice';

const DOCUMENT_ID_LENGTH = 35;

export const ServiceOrderToolbarSearch = () => {
    return (
        <ToolbarSearch
            getSearchTerm={getServiceOrderSearch}
            setSearchTerm={setServiceOrderSearch}
            tooltipMessageId="outboundPortal.serviceOrders.table.toolbar.search.placeholder.tooltip"
            placeholderMessageId="outboundPortal.serviceOrders.table.toolbar.search.placeholder"
            maxLengthInput={DOCUMENT_ID_LENGTH}
        />
    );
};
